/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetRemoveItemFeedbackQuestionsQueryVariables = Types.Exact<{
  skuId: Types.Scalars["ID"]["input"];
}>;
export type GetRemoveItemFeedbackQuestionsQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    wardrobe: {
      __typename?: "WardrobeContentModule";
      boughtModule: {
        __typename?: "WardrobeBoughtModule";
        removeBoughtItemModal: {
          __typename?: "WardrobeRemoveBoughtItemModal";
          heading: string;
          subheading: string;
          feedbackQuestions: {
            __typename?: "KeptItemFeedbackQuestionSet";
            questionSetId: string;
            questions: Array<{
              __typename?: "KeptItemFeedbackFreeformQuestion";
              questionId: string;
              label: string;
              secondaryLabel?: string | null;
              value?: string | null;
            } | {
              __typename?: "KeptItemFeedbackMultipleChoiceQuestion";
              questionId: string;
              label: string;
              options: Array<{
                __typename?: "KeptItemFeedbackMultipleChoiceQuestionOption";
                questionId: string;
                label: string;
                value: boolean;
              }>;
            }>;
          };
        };
      };
    };
  } | null;
};
export type RemoveItemModalFragment = {
  __typename?: "WardrobeRemoveBoughtItemModal";
  heading: string;
  subheading: string;
  feedbackQuestions: {
    __typename?: "KeptItemFeedbackQuestionSet";
    questionSetId: string;
    questions: Array<{
      __typename?: "KeptItemFeedbackFreeformQuestion";
      questionId: string;
      label: string;
      secondaryLabel?: string | null;
      value?: string | null;
    } | {
      __typename?: "KeptItemFeedbackMultipleChoiceQuestion";
      questionId: string;
      label: string;
      options: Array<{
        __typename?: "KeptItemFeedbackMultipleChoiceQuestionOption";
        questionId: string;
        label: string;
        value: boolean;
      }>;
    }>;
  };
};
export type FeedbackQuestionsFragment = {
  __typename?: "KeptItemFeedbackQuestionSet";
  questionSetId: string;
  questions: Array<{
    __typename?: "KeptItemFeedbackFreeformQuestion";
    questionId: string;
    label: string;
    secondaryLabel?: string | null;
    value?: string | null;
  } | {
    __typename?: "KeptItemFeedbackMultipleChoiceQuestion";
    questionId: string;
    label: string;
    options: Array<{
      __typename?: "KeptItemFeedbackMultipleChoiceQuestionOption";
      questionId: string;
      label: string;
      value: boolean;
    }>;
  }>;
};
export const FeedbackQuestionsFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "FeedbackQuestions"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "KeptItemFeedbackQuestionSet"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "questionSetId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "questions"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "questionId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "KeptItemFeedbackMultipleChoiceQuestion"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "options"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "questionId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "label"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "KeptItemFeedbackFreeformQuestion"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "questionId"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "label"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "secondaryLabel"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const RemoveItemModalFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "RemoveItemModal"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "WardrobeRemoveBoughtItemModal"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "heading"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "subheading"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "feedbackQuestions"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "FeedbackQuestions"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "FeedbackQuestions"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "KeptItemFeedbackQuestionSet"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "questionSetId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "questions"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "questionId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "KeptItemFeedbackMultipleChoiceQuestion"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "options"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "questionId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "label"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "KeptItemFeedbackFreeformQuestion"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "questionId"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "label"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "secondaryLabel"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const GetRemoveItemFeedbackQuestionsDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getRemoveItemFeedbackQuestions"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "skuId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "wardrobe"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "boughtModule"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "removeBoughtItemModal"
                    },
                    arguments: [{
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "skuId"
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "skuId"
                        }
                      }
                    }],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RemoveItemModal"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "FeedbackQuestions"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "KeptItemFeedbackQuestionSet"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "questionSetId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "questions"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "questionId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "KeptItemFeedbackMultipleChoiceQuestion"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "options"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "questionId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "label"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "KeptItemFeedbackFreeformQuestion"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "questionId"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "label"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "secondaryLabel"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "RemoveItemModal"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "WardrobeRemoveBoughtItemModal"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "heading"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "subheading"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "feedbackQuestions"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "FeedbackQuestions"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetRemoveItemFeedbackQuestionsQuery__
 *
 * To run a query within a React component, call `useGetRemoveItemFeedbackQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoveItemFeedbackQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoveItemFeedbackQuestionsQuery({
 *   variables: {
 *      skuId: // value for 'skuId'
 *   },
 * });
 */
export function useGetRemoveItemFeedbackQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables> & ({
  variables: GetRemoveItemFeedbackQuestionsQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>(GetRemoveItemFeedbackQuestionsDocument, options);
}
export function useGetRemoveItemFeedbackQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>(GetRemoveItemFeedbackQuestionsDocument, options);
}
// @ts-ignore
export function useGetRemoveItemFeedbackQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>;
export function useGetRemoveItemFeedbackQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRemoveItemFeedbackQuestionsQuery | undefined, GetRemoveItemFeedbackQuestionsQueryVariables>;
export function useGetRemoveItemFeedbackQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>(GetRemoveItemFeedbackQuestionsDocument, options);
}
export type GetRemoveItemFeedbackQuestionsQueryHookResult = ReturnType<typeof useGetRemoveItemFeedbackQuestionsQuery>;
export type GetRemoveItemFeedbackQuestionsLazyQueryHookResult = ReturnType<typeof useGetRemoveItemFeedbackQuestionsLazyQuery>;
export type GetRemoveItemFeedbackQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetRemoveItemFeedbackQuestionsSuspenseQuery>;
export type GetRemoveItemFeedbackQuestionsQueryResult = Apollo.QueryResult<GetRemoveItemFeedbackQuestionsQuery, GetRemoveItemFeedbackQuestionsQueryVariables>;